/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeCreateCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeCreateCtrl', ["dialog", "$q", "$scope", "$state", "Stocktakes", "StocktakeTemplates", "StockItemSuperGroups", "title", function(dialog, $q, $scope, $state, Stocktakes, StocktakeTemplates, StockItemSuperGroups, title) {
  title.set('Create Stocktake');

  $scope.userTemplate = StocktakeTemplates.getAllActive();
  $scope.systemTemplates = StockItemSuperGroups.getAll();

  $scope.loader = $q.all([
    $scope.userTemplate.$promise,
    $scope.systemTemplates.$promise
  ]);

  $scope.deleteTemplate = function(template, index) {
    StocktakeTemplates.remove(template)
    .then(function() {
      $scope.userTemplate.splice(index, 1);
    });
  };
}]);
